/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import store from '../../../store'



let urlSlug = ''
if (localStorage.getItem('slug') != null) {
  urlSlug = localStorage.getItem('slug')
}

var navMenuItems = [];
if (store.getters.roles == 'super_admin') {
  navMenuItems = [{
      url: '/admin/dashboard',
      name: 'Dashboard',
      slug: "dashboard",
      icon: 'HomeIcon',
      i18n: 'Dashboard',
    },

    {
      url: '/admin/companies',
      name: "Companies",
      slug: "companies",
      icon: 'UsersIcon',
      i18n: 'Companies',
    },

    /*
      {
        url: '/admin/users',
        name: 'Users',
        slug: "users",
        icon: 'UserIcon',
        i18n: 'Users',
      },*/

  ]


}


if (store.getters.roles == 'company_admin') {

  navMenuItems = [{
      url: '/' + urlSlug + '/admin/dashboard',
      name: 'Dashboard',
      slug: "dashboard",
      icon: 'HomeIcon',
      i18n: 'Dashboard',
    },


    {
      url: '/' + urlSlug + '/admin/staff',
      name: "Staff",
      slug: "staff",
      icon: 'UserIcon',
      i18n: 'Staffs',
    },

    {
      url: '/' + urlSlug + '/admin/department',
      name: "Department",
      slug: "department",
      icon: 'PackageIcon',
      i18n: 'Departments',
    },
    {
      url: '/' + urlSlug + '/admin/appointment',
      name: "Appointment",
      slug: "appointment",
      icon: 'CalendarIcon',
      i18n: 'Appointments',
    },
    /*
      {
        url: '/admin/users',
        name: 'Users',
        slug: "users",
        icon: 'UserIcon',
        i18n: 'Users',
      },*/

  ]


}

if (store.getters.roles == 'staff') {
  navMenuItems = [{
      url: '/' + urlSlug + '/staff/dashboard',
      name: 'Dashboard',
      slug: "dashboard",
      icon: 'HomeIcon',
      i18n: 'Dashboard',
    },

    {
      url: null,
      name: 'Time Slot',
      icon: 'ClockIcon',
      i18n: 'TimeSlot',
      submenu: [
        {
          url: '/' + urlSlug + '/staff/time-slot',
          name: "Default Slot",
          slug: "time-slot",
          i18n: 'DefaultSlot',
        },
        {
          url: '/' + urlSlug + '/staff/custom-slot',
          name: "Custom Slot",
          slug: "custom-slot",
          i18n: 'CustomSlot',
        },
      ]
    },

    // {
    //   url: '/' + urlSlug + '/staff/time-slot',
    //   name: "Time Slot",
    //   slug: "time-slot",
    //   icon: 'ClockIcon',
    //   i18n: 'TimeSlot',
    // },
    // {
    //   url: '/' + urlSlug + '/staff/custom-slot',
    //   name: "Custom Slot",
    //   slug: "custom-slot",
    //   icon: 'PackageIcon',
    //   i18n: 'Custom Slot',
    // },
    {
      url: '/' + urlSlug + '/staff/appointment',
      name: "Appointment",
      slug: "appointment",
      icon: 'CalendarIcon',
      i18n: 'Appointments',
    },

  ]


}

export default navMenuItems
